/**
 * @desc TMS调拨单批量退件签收
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.fulfilment.OutReturnSignRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/batchReturnSigning`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
